import { Icon } from '@livable/saas-react-components';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import useStyles from './styles';
export default function BreadcrumbsList(_ref) {
  let _ref$breadcrumbsArray = _ref.breadcrumbsArray,
    breadcrumbsArray = _ref$breadcrumbsArray === void 0 ? [] : _ref$breadcrumbsArray,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'h6' : _ref$size;
  const classes = useStyles();
  const breadcrumbs = breadcrumbsArray.map(breadcrumb => {
    if (breadcrumb.link) {
      return /*#__PURE__*/React.createElement(Link, {
        key: breadcrumb.title,
        component: RouterLink,
        to: breadcrumb.link,
        underline: "none",
        state: {
          tab: breadcrumb.tab
        }
      }, /*#__PURE__*/React.createElement(Typography, {
        variant: size,
        color: breadcrumb.isDisabled ? 'disabled' : ''
      }, breadcrumb.icon, breadcrumb.title));
    }
    return /*#__PURE__*/React.createElement(Typography, {
      variant: size,
      key: breadcrumb.title,
      color: breadcrumb.isDisabled ? 'disabled' : ''
    }, breadcrumb.icon, breadcrumb.title);
  });
  return /*#__PURE__*/React.createElement(Breadcrumbs, {
    className: classes.breadcrumbs,
    separator: /*#__PURE__*/React.createElement(Icon, {
      type: "arrow-line-right-bold"
    }),
    "aria-label": "breadcrumb"
  }, breadcrumbs);
}
BreadcrumbsList.propTypes = {
  breadcrumbsArray: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    link: PropTypes.string
  })),
  size: PropTypes.string
};